import styled, { css } from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  .black2 {
    word-break: break-all;
    ${(props) => {
      return (
        props.disabled &&
        css`
          color: ${color.black3};
        `
      );
    }}
  }
  .black3 {
    word-break: break-all;
    ${(props) => {
      return (
        props.disabled &&
        css`
          color: ${color.black4};
        `
      );
    }}
  }

  .ant-avatar {
    margin-right: 8px;
    background-color: ${color.orange6};
    color: ${color.orange1};
    border: 1px solid ${color.grey1};
    .ant-avatar-string {
      line-height: 44px !important;
    }
  }

  .component_accountCard_custom_name {
    display: inline-flex;
    align-items: center;
    column-gap: 4px;
  }
`;

export default Wrapper;
